import { render, staticRenderFns } from "./ContentClinicPrint.vue?vue&type=template&id=39c1b3d0&scoped=true"
import script from "./ContentClinicPrint.vue?vue&type=script&lang=js"
export * from "./ContentClinicPrint.vue?vue&type=script&lang=js"
import style0 from "./ContentClinicPrint.vue?vue&type=style&index=0&id=39c1b3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1b3d0",
  null
  
)

export default component.exports